// src/components/headerone/bots/Five9Bot.js
// Five9 chat widget (channel for testing Omni + Agent Assist integration on State of GTS).
// Loads the Five9 chat wrapper and initializes it once. The widget is self-contained:
// it renders its own launcher and manages its own UI. The bot switcher shows/hides it
// via the body[data-gts-active-bot="five9"] CSS gating in Main.js.
import { useEffect } from 'react';

const WRAPPER_SRC = 'https://cdn.prod.us.five9.net/static/stable/chat/wrapper/index.js';
const SCRIPT_ID = 'five9-chat-wrapper';
const F9_CONFIG = {
  cdn: 'prod',
  integrationId: '585d1e1f-1239-4c9c-ba6e-e1cedd15a5da',
  chatDeploymentId: '59e0284d-68ba-4883-b933-3a0d46d32d93',
};

function initFive9() {
  try {
    const Wrapper = window.F9 && window.F9.Chat && window.F9.Chat.Wrapper;
    if (Wrapper && typeof Wrapper.init === 'function') {
      // Initialize only once; the widget persists across switcher toggles.
      if (!window.__five9Initialized) {
        Wrapper.init({ ...F9_CONFIG });
        window.__five9Initialized = true;
        console.log('[Five9] Chat wrapper initialized');
      }
      return true;
    }
  } catch (e) {
    console.warn('[Five9] init error', e);
  }
  return false;
}

function Five9Bot() {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    document.body.dataset.gtsActiveBot = 'five9';

    // If the wrapper is already loaded (e.g. switching back to Five9), init now.
    if (initFive9()) return undefined;

    // Otherwise load the wrapper script once, then init on load.
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = WRAPPER_SRC;
      script.async = true;
      script.addEventListener('load', initFive9);
      document.head.appendChild(script);
    }

    // Poll briefly in case F9 becomes available shortly after the script loads.
    const poll = setInterval(() => { if (initFive9()) clearInterval(poll); }, 250);
    const stop = setTimeout(() => clearInterval(poll), 15000);

    return () => { clearInterval(poll); clearTimeout(stop); };
  }, []);

  return null;
}

export default Five9Bot;
